import { GameObjects, Scene } from "phaser";
import { Translation } from "../../Translation";

export class CharInfoBox extends GameObjects.Container {
    constructor(scene: Scene, x: number, y: number, id: string) {
        super(scene, x, y);

        const image = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "char_file_" + id + ".png");
        this.add(image);

        const style = { fontFamily: "Oswald-Medium", fontSize: "15px", color: "#FFFFFF" };

        const xx = -50;
        const analysis = new Phaser.GameObjects.Text(scene, xx, -15, Translation.getText("ANALYSIS"), style);
        this.add(analysis);
        const aggressiveness = new Phaser.GameObjects.Text(scene, xx, 11, Translation.getText("AGRESSIVENESS"), style);
        this.add(aggressiveness);
        const volatility = new Phaser.GameObjects.Text(scene, xx, 41, Translation.getText("VOLATILITY"), style);
        this.add(volatility);
    }
}